import React, { useContext } from "react";
import {
  ChildContactFormWrapper,
  ContactFormWrapper,
  ContactMe,
  HeadingWrapper,
  StyledHeading,
} from "../components/contactForm/contactForm.styled";
import { useNavigate } from "react-router-dom";
import { ContactForm } from "../components/contactForm/contactForm";
import { StyledAiOutlineArrowLeft } from "../components/common/styles/common.styled";
import { DrawerContext } from "../components/ReactContext/DrawerContext";

export const ContactPage = () => {
  const navigate = useNavigate();
  const { showSidebar } = useContext(DrawerContext);

  return (
    <ContactFormWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2 }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
      isOpen={showSidebar}
    >
      <ChildContactFormWrapper>
        <ContactMe>&lt;ContactMe&gt;</ContactMe>
        <HeadingWrapper>
          <StyledHeading>
            <StyledAiOutlineArrowLeft onClick={() => navigate(-1)} />
            Contact Me
          </StyledHeading>
        </HeadingWrapper>
        <ContactForm className="ContactForm" />
        <ContactMe>&lt;ContactMe&gt;</ContactMe>
      </ChildContactFormWrapper>
    </ContactFormWrapper>
  );
};
